function Stages9() {
	return ( 
		<div>
			<div>
				<p>
					Der Baumstamm ist nun eine faserige Masse, von Moos überwachsen und kaum mehr als Holzstruktur erkennbar.
				</p>
			</div>
		</div>
	 );
}

export default Stages9;